if (!customElements.get('size-chart-metafields-switcher')) {
  class SizeChartMetafieldsSwitcher extends HTMLElement {
    connectedCallback() {
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick(event) {
      const button = event.target.closest('button[data-size]');
      if (!button || !this.contains(button)) return;

      const size = button.dataset.size;
      if (!size) return;

      this.querySelectorAll('[data-size]').forEach(function (el) {
        const isActive = el.dataset.size === size;
        el.classList.toggle('is-active', isActive);
        if (el.tagName === 'BUTTON') {
          el.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        }
      });
    }
  }

  customElements.define('size-chart-metafields-switcher', SizeChartMetafieldsSwitcher);
}
